<template>
  <Dialog :open="show" @update:open="onUpdateDialog">
    <DialogScrollContent>
      <DialogHeader>
        <DialogTitle>
          {{ $t('Scan QR Code') }}
        </DialogTitle>
      </DialogHeader>

      <QrcodeStream @detect="onDetect"></QrcodeStream>
    </DialogScrollContent>
  </Dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { Dialog, DialogHeader, DialogTitle } from '@/shadcn/components/ui/dialog'
import { DialogScrollContent } from '@/components/ui/dialog'
import { QrcodeStream } from 'vue-qrcode-reader'

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  }
})

const emits = defineEmits([
  'discard',
  'scan',
])

const showQrCode = ref(props.show)

watch(() => props.show, (newValue) => {
    onUpdateDialog(newValue)
})

const onUpdateDialog = (value) => {
  showQrCode.value = value

  if (!value) {
    emits('discard')
  }
}

const onDetect = (data) => {
  console.log(data)
  emits('scan', data[0]?.rawValue)
}
</script>
